<template>
  <RevTooltip position="right">
    <template #trigger="{ show, hide }">
      <RevButton
        size="small"
        variant="primary"
        @click="handleCopyClick(show, hide)"
      >
        {{ i18n(translations.copy) }}
      </RevButton>
    </template>

    {{ i18n(translations.confirmation) }}
  </RevTooltip>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevTooltip } from '@ds/components/Tooltip'

import translations from './CopyTokenToClipboard.translations'

const props = defineProps<{
  token: string
}>()

const i18n = useI18n()

function handleCopyClick(show: () => void, hide: () => void) {
  show()

  navigator.clipboard.writeText(props.token)

  setTimeout(() => {
    hide()
  }, 2000)
}
</script>
